import { Box, Grid, Typography, Button } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import AdjustIcon from "@mui/icons-material/Adjust";
import React from "react";
import { useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import AddressCard from "../adreess/AdreessCard";

const OrderCard = ({ item, order }) => {
  const navigate = useNavigate();
  const shipping = order?.shippingAddress;

  const handleCopyAWB = () => {
    if (order?.awbNo) {
      navigator.clipboard.writeText(order.awbNo);
      alert("AWB Number copied to clipboard!");
    }
  };

  const handleTrack = () => {
    // if (order?.awbNo) {
    //   window.open(
    //     `https://bluedart.com/trackdartresultthirdparty?trackFor=0&trackNo=${order.awbNo}`,
    //     // `https://www.bluedart.com/tracking?tracknumbers=${order.awbNo}`,
    //     "_blank"
    //   );
    // }
    if (order?.awbNo) {
      navigate(`/account/order/${order?._id}/track`)
    }
  };

  return (
    <Box className="p-5 shadow-lg hover:shadow-2xl border">
      {/* Top: AWB and Address */}
      <div className="mb-4 flex justify-between items-center">
        <div>
          <p className="text-sm font-semibold">
            🧾 AWB No:{" "}
            <span className="font-normal">
              {order?.awbNo || "Not Available"}
            </span>
          </p>
          {shipping && (
            <p className="text-xs text-gray-600">
              <span className="font-medium">Ship to:</span>{" "}
              {shipping?.firstName}, {shipping?.streetAddress},{" "}
              {shipping?.city}, {shipping?.state} - {shipping?.zipCode}
            </p>
          )}
        </div>

        {/* Buttons */}
        {order?.awbNo && (
          <div className="flex space-x-2">
            <Button
              size="small"
              variant="outlined"
              startIcon={<ContentCopyIcon />}
              onClick={handleCopyAWB}
            >
              Copy
            </Button>
            <Button
              size="small"
              variant="contained"
              startIcon={<LocalShippingIcon />}
              onClick={handleTrack}
            >
              Track
            </Button>
          </div>
        )}
      </div>

      {/* Order Item Display */}
      <Grid spacing={2} container sx={{ justifyContent: "space-between" }}>
        <Grid item xs={6}>
          <div
            onClick={() => navigate(`/account/order/${order?._id}`)}
            className="flex cursor-pointer"
          >
            <img
              className="w-[5rem] h-[5rem] object-cover object-top"
              src={
                item?.product?.colorVariants?.[0]?.images?.find(
                  (img) => img?.label === "front"
                )?.url
              }
              alt=""
            />
            <div className="ml-5">
              <p className="mb-2">{item?.product?.title}</p>
              <p className="opacity-50 text-xs font-semibold space-x-5">
                <span>Size: {item?.size}</span>
              </p>
              <p>₹{item?.price}</p>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={6}>
          <AddressCard address={shipping} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default OrderCard;
